import { UpdateParameterRequest } from '@src/main/modules/parameters/infrastructure/dto/updateParameterRequest';
import { createParameterHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/ParameterHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const updateParameterUseCase = async (
  id: string,
  data: UpdateParameterRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createParameterHttpRepository(tokenProvider);
  return await repository.update(id, data);
};
